var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_8637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46793 12.6338C8.49006 12.689 8.52854 12.7361 8.57819 12.7687C8.62785 12.8014 8.68631 12.8181 8.74572 12.8166C8.80513 12.815 8.86266 12.7954 8.91058 12.7602C8.95849 12.7251 8.99451 12.6761 9.01379 12.6199L12.8004 1.55117C12.8191 1.49956 12.8226 1.44369 12.8107 1.39013C12.7988 1.33656 12.7718 1.2875 12.733 1.24869C12.6942 1.20989 12.6451 1.18293 12.5916 1.17099C12.538 1.15904 12.4821 1.1626 12.4305 1.18125L1.36183 4.9679C1.30561 4.98718 1.25664 5.0232 1.22148 5.07112C1.18632 5.11903 1.16666 5.17656 1.16513 5.23597C1.16361 5.29539 1.1803 5.35385 1.21296 5.4035C1.24562 5.45316 1.29269 5.49163 1.34785 5.51376L5.96757 7.36631C6.11361 7.42478 6.2463 7.51222 6.35763 7.62336C6.46897 7.73449 6.55665 7.86702 6.61538 8.01296L8.46793 12.6338Z",
    stroke: "white",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7316 1.25L6.3584 7.62265",
    stroke: "white",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_8637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9815,
    height: 13.9815,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e05a29b7c25fc054de04a0135a96118b.svg";
export { ForwardRef as ReactComponent };